import React from "react";
import { Helmet } from 'react-helmet-async';
import Navbar from "./components/Navbar";
import Landing from "./components/Landing";
import History from "./components/Histroy";
import Team from "./components/Team";
import Testimonials from "./components/Testimonials";
import Services from "./components/Services";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import LogoScroller from "./components/LogoScroller";
import Owners from "./components/Owners";
import SEOHelmet from "./components/SEOHelmet";

import "../styles/Home.scss";

function __MAIN__() {
  /* Irgendwann fixen wenn ich den nerv dazu hab */
  window.addEventListener('scroll', () => {
    const reveals = document.querySelectorAll('.reveal');

    for (let i = 0; i < reveals.length; i++) {
      let windowHeight = window.innerHeight;
      let revealTop = reveals[i].getBoundingClientRect().top;
      let revealPoint = 150;

      if (revealTop < windowHeight - revealPoint) {
        reveals[i].classList.add('active');
      } else {
        reveals[i].classList.remove('active');
      }
    }
  });

  return (
    <div>
      <SEOHelmet
        title="Computer Center Lorentschitsch - IT-Service, Reparatur & Netzwerklösungen in Österreich"
        description="Computer Center Lorentschitsch - Ihr IT-Partner seit 1978. EDV-Dienstleistungen, Sofort-Reparatur, Netzwerklösungen, Hardware & Software. Kompetente Beratung und schneller Service in Österreich."
        keywords="Computer Reparatur, IT-Service, EDV-Dienstleistungen, Netzwerklösungen, Hardware, Software, PC Reparatur, Laptop Reparatur, IT-Support, Computer Center, Lorentschitsch, Österreich, Gaming PC, CAD Workstation"
        canonical="https://lorentschitsch.at/"
      />

      {/* Structured Data for Organization */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Computer Center Lorentschitsch",
            "url": "https://lorentschitsch.at",
            "logo": "https://lorentschitsch.at/img/misc/logo.png",
            "description": "IT-Dienstleistungen, Computer-Reparatur, Netzwerklösungen und Hardware-Support seit 1978",
            "foundingDate": "1978",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "AT"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "availableLanguage": "German"
            },
            "sameAs": [
              "https://shop.lorentschitsch.at/"
            ]
          })}
        </script>
      </Helmet>

      <Navbar />
      <div id="landing"><Landing /></div>
      <div id="services"><Services /></div>
      <div id="owners"><Owners /></div>
      <div id="team"><Team /></div>
      <div id="history"><History /></div>
      <div id="testimonials"><Testimonials /></div>
      <div id="contact"><Contact /></div>
      <div id="logos"><LogoScroller /></div>
      <div id="footer"><Footer /></div>

    </div>
  );
}

export default __MAIN__;